import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi';
import { useDispatch } from 'react-redux';
import { setAppLoading } from '../../../../store/common/generalSlice';
import { Col, Row, Tooltip } from 'antd';
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation';
import carPlaceHolder from '../../../../assets/images/car.png'
import { getEllipsedString, getFormattedDateTime, getServicesList } from '../../../../config/utils';
import CarRegistrationNumberPlate from '../../../../components/Elements/CarRegistrationNumberPlate';
import { LuMapPin } from 'react-icons/lu';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaCircleCheck } from 'react-icons/fa6';
import { statusIdentifier } from '../../../../config/utils/StatusIdentifier';
import { transactionStatus } from '../../../../config/utils/TransactionStatus';
import { BsCalendarCheckFill } from 'react-icons/bs';



const priceCalculation = (quotePrice = 0, amendPrice = 0) => {
    return quotePrice + amendPrice
}

const TransactionDetail = () => {

    const { id } = useParams();
    const { getUserBookingDetails } = useBookingApi()
    const [data, setData] = useState(null)
    const [bookingStatus, setBookingStatus] = useState({
        color: '',
        status: ''
    })
    const [accumulatedPrice, setAccumulatedPrice] = useState(0);
    const dispatch = useDispatch()

    const bookingDetail = async () => {
        try {
            dispatch(setAppLoading(true))
            let response = await getUserBookingDetails(id);
            if (response?.status == 200) {
                setData(response?.data)
                dispatch(setAppLoading(false))
            } else {
                dispatch(setAppLoading(false))
            }
        } catch (error) {
            dispatch(setAppLoading(false))
        }
    }

    useEffect(() => {
        bookingDetail()
    }, [id])

    useEffect(() => {
        if (data) {
            const { colorClass, status } = statusIdentifier(data?.bookingDetails?.status);
            if (data?.bookingDetails?.bookingAmendment) {
                if (data?.bookingDetails?.quotes?.length > 0) {
                    setAccumulatedPrice(priceCalculation(data?.bookingDetails?.quotes?.[0]?.price, data?.bookingDetails?.bookingAmendment?.price))
                }
            } else {
                setAccumulatedPrice(data?.bookingDetails?.quotes?.length > 0 ? data?.bookingDetails?.quotes?.[0]?.price : 0)
            }
            setBookingStatus({
                color: colorClass,
                status: status
            })

        }
    }, [data])


    return (
        data &&
        <Row className='w-full flex flex-col gap-3'>
            <TitleWithBackNavigation
                title={'Details'}
                link={'/settings/transactions'}
            />
            <Row className='w-full bg-white p-5 flex flex-col gap-5'>
                <Col lg={24} className='flex justify-center sm:justify-between items-center w-full  gap-4 sm:gap-0 flex-wrap'>
                    <div className='flex justify-center sm:justify-start items-center gap-4 flex-wrap w-full sm:w-fit'>
                        <img src={carPlaceHolder} className='w-fit h-14' />
                        <div className='flex flex-col'>
                            <h3 className='text-xl font-semibold sm:text-left text-center whitespace-nowrap'>
                                {
                                    getEllipsedString(data?.bookingDetails?.serviceProvider?.userDetail?.businessName, 15)
                                }
                            </h3>
                            <div className='flex sm:justify-start justify-center'>
                                {
                                    data?.bookingDetails?.services &&
                                        data?.bookingDetails?.services.length ?
                                        data?.bookingDetails?.services.slice(0, 3).map((service, sIdx) => (
                                            <span key={'ser1' + sIdx}>
                                                <p className='text-gray-500 font-semibold text-xs break-all' >
                                                    {service?.name}

                                                    {sIdx < data?.bookingDetails?.services.slice(0, 3).length - 1 &&
                                                        (<span className='mx-1'>|</span>)}
                                                    {sIdx == 2 && data?.bookingDetails?.services.length > 3 ?
                                                        (<span className='mr-1'>...</span>) : ''}
                                                </p>
                                            </span>
                                        )) : (
                                            <small className='text-xs mb-3'>Services not available</small>
                                        )}
                            </div>
                        </div>
                    </div>
                    <div className='flex items-center gap-4 flex-wrap'>
                        <p className={bookingStatus?.color}>
                            {bookingStatus?.status}
                        </p>
                        <div className='w-fit'>
                            <CarRegistrationNumberPlate
                                regNumber={data?.bookingDetails?.vehicleRegistrationNo}
                            />
                        </div>
                    </div>
                </Col>

                <div className='w-full border-b border-dashed border-gray-200'></div>

                <Col lg={24} className='flex items-center gap-4 flex-wrap-reverse'>

                    <div className='flex items-center gap-3 sm:mb-0 mb-2 w-fit'>
                        <div className=''>
                            <LuMapPin className='text-2xl text-white bg-primary p-[3px] rounded-full' />
                        </div>
                        <small className='text-xs font-md break-all'>{data?.bookingDetails?.address ? data?.bookingDetails?.address : '-'}</small>
                    </div>

                    <div className='flex items-center gap-3 sm:mb-0 mb-2 w-fit'>
                        <div className=''>
                            <FaCalendarAlt className='bg-[#fa3434] text-white rounded-full p-[5px] text-2xl' />
                        </div>
                        <small className='text-xs font-md'>
                            {
                                data?.bookingDetails && data?.bookingDetails?.createdAt ?
                                    getFormattedDateTime(`${data?.bookingDetails?.createdAt}`, 'DD-MM-YYYY HH:mm')
                                    : '-'
                            }
                        </small>
                    </div>

                    {
                        data?.bookingDetails?.status == 1 &&
                        data?.bookingDetails?.updatedAt &&
                        <div className='flex items-center gap-3 sm:mb-0 mb-2 w-fit'>
                            <div className=''>
                                <BsCalendarCheckFill className='bg-[#000] text-white rounded-full p-[5px] text-2xl' />
                            </div>
                            <small className='text-xs font-md'>
                                {
                                    getFormattedDateTime(`${data?.bookingDetails?.updatedAt}`, 'DD-MM-YYYY HH:mm')
                                }
                            </small>
                        </div>
                    }

                </Col>

                <div className='w-full border-b border-dashed border-gray-200'></div>

                <Col className='flex flex-col items-start gap-2'>
                    <h6 className='font-normal text-sm'>Services Requested:</h6>
                    <div className='flex sm:flex-row flex-col gap-2 md:gap-4'>
                        {
                            data?.bookingDetails?.services &&
                                data?.bookingDetails.services.length > 0 ? (
                                <React.Fragment>
                                    {data?.bookingDetails.services.slice(0, 3).map((service, sIdx) => (
                                        <div className='flex items-center sm:mr-2 mb-2' key={'ser2' + sIdx}>
                                            <div className='w-[20px]'>
                                                <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                            </div>
                                            <small className='font-md text-xs'>{service?.name}</small>
                                        </div>
                                    ))}
                                    {data?.bookingDetails?.services?.length > 3 ? (
                                        <Tooltip title={getServicesList(data?.bookingDetails?.services)}>
                                            <p className='text-xs cursor-pointer'>show all</p>
                                        </Tooltip>
                                    ) : ''}
                                </React.Fragment>
                            )
                                : (
                                    <small className='text-xs'>Services not available</small>
                                )
                        }
                    </div>
                </Col>

                <div className='w-full border-b border-dashed border-gray-200'></div>

                <Col lg={24} className='flex flex-col items-start gap-2'>
                    <h6 className='font-normal text-sm'>Additional Info/Note</h6>
                    <small className='text-xs font-md break-all'>{data?.bookingDetails?.details ? data?.bookingDetails?.details : '-'}</small>
                </Col>

                <div className='w-full border-b border-dashed border-gray-200'></div>

                {
                    data?.bookingDetails?.transactions?.length > 0 &&
                    data?.bookingDetails?.transactions?.map((transaction, index) => {
                        return (
                            <Col lg={24} className='flex flex-col items-start gap-1'>
                                <h6 className={`font-normal text-sm ${data?.bookingDetails?.transactions?.length - 1 == index && 'font-semibold'}`}>{transactionStatus(transaction?.type)}</h6>
                                <small className='text-lg font-bold'>£{transaction?.amount ? transaction?.amount?.toFixed(2) : 0}</small>
                            </Col>
                        )
                    })
                }

                <Col lg={24} className='flex flex-col items-start gap-1'>
                    <h6 className='font-normal text-sm'>Total Amount</h6>
                    <small className='text-lg font-bold'>£{accumulatedPrice}</small>
                </Col>
            </Row>

        </Row>
    )
}

export default TransactionDetail